module.exports = __webpack_public_path__ + "static/media/beats_page 1.1b6236d6.png";